module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Color-profile-5fb9f0d2389c13a4a5d6fdc2ae79d68d.svg";